// import React, { useEffect, useState } from "react";
// import { withRouter } from "react-router-dom";
// import userService from "../../services/userService";
// import authService from "../../services/authService";
// import { connect, useSelector } from "react-redux";
// import { setCurrentUser } from "../../redux/user/user.actions";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import { useLocation } from "react-router-dom";
// import {
//   Box,
//   Typography,
//   Button,
//   FormControl,
//   Select,
//   MenuItem,
//   Paper,
//   Chip,
// } from "@mui/material";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import PeopleIcon from "@mui/icons-material/People";
// import paymentServices from "../../services/paymentServices";
// import { toast, ToastContainer } from "react-toastify";

// function PriceTag({
//   price_detail,
//   planPeriod,
//   planName,
//   planList,
//   plan_mode,
//   price_size = "50px",
//   bg_color = "bg-gray",
//   hide,
//   history,
//   currentUser,
//   hide_mode,
//   plan_id,
//   defaultPlan,
//   setCurrentPlan,
//   setCurrentplancheck,
//   setCurrentUser,
// }) {
//   let detail = { price: null, user_count: null, period: null, plan_mode: null };
//   const [details, setdetails] = useState(detail);
//   const [user_count_list, setuser_count] = useState([]);
//   let [plan_period, setplan_period] = useState(planPeriod);
//   const [location, setLocation] = useState(useLocation());
//   const userDetails = useSelector((user) => user);

//   useEffect(() => {
//     setplan_period(planPeriod);
//     plan_period = planPeriod;
//     initialCall();
//   }, [planPeriod]);

//   const initialCall = () => {
//     let time_period = Object.keys(price_detail);
//     if (!plan_period) {
//       let first_plan_period = time_period[0];
//       let { price, user_count } = price_detail[first_plan_period][0];
//       setdetails({ price, user_count, period: first_plan_period });
//       setuser_count(price_detail[first_plan_period]);
//       setplan_period(first_plan_period);
//     } else {
//       let { price, user_count } = price_detail[plan_period][0];
//       setdetails({ price, user_count, period: plan_period });
//       setuser_count(price_detail[plan_period]);
//     }
//   };

//   const dropOnChange = (count) => {
//     let arr = price_detail[plan_period];
//     let findObj = arr.find((obj) => obj.user_count == count);
//     const { price, user_count } = findObj;
//     setdetails({ price, user_count, period: plan_period });
//   };

//   const getUpdatedUser = (response) =>
//     response?.user || response?.data?.user || response?.data?.data?.user;

//   const isSubscriptionUpdateSuccessful = (response) => {
//     const status = Number(response?.status || response?.data?.status);
//     return (
//       status === 200 ||
//       response?.success === true ||
//       Boolean(getUpdatedUser(response)?.plan)
//     );
//   };

//   const redirectToLogin = () => {
//     sessionStorage.removeItem("token");
//     localStorage.removeItem("token");
//     localStorage.removeItem("is_guest");
//     localStorage.removeItem("guest_id");
//     setCurrentUser(null);
//     history.replace("/login");
//   };

//   const  buyPlan = async() => {
//       let data = {
//         ...details,
//         planName,
//         plan_id,
//         plan_mode: plan_mode.mode,
//       };
//       const user = authService.getCurrentUser();

//       if (
//         currentUser?.planName !== data.planName &&
//         currentUser?.planName !== "PET Basic Plan"
//       ) {
//         // Swal.fire({
//         //   title: `${currentUser.planName} features will no longer exist with ${data.planName}`,
//         //   type: "warning",
//         //   showCancelButton: true,
//         //   showCloseButton: true,
//         //   confirmButtonText: "Okay!",
//         //   cancelButtonText: "Cancel",
//         // }).then(async (result) => {
//           // if (result.value === true) {
//             if (user) {
//               // history.push({
//               //   pathname: `/payment`,
//               //   state: { data: data },
//               // });
//               const updateDetails = {
//                 planId: plan_id,
//                 planName: planName,
//                 userEmail: userDetails.user?.currentUser?.email,
//                 duration: data.period,
//               };
//               console.log("updateDetails", updateDetails, data, userDetails.user);
//               const updateDet = await paymentServices.UpdateSubs(updateDetails);
//               console.log("updateDet", updateDet);
//               if (isSubscriptionUpdateSuccessful(updateDet)) {
//                 const updatedUser = getUpdatedUser(updateDet);

//                 toast.success("Updated Successfully");
//                 setCurrentplancheck((prev) => !prev);
//                 if (updatedUser) {
//                   setCurrentUser(updatedUser);
//                 }
//                 if (updatedUser?.plan?.name) {
//                   setCurrentPlan(updatedUser.plan.name);
//                 }
//                 redirectToLogin();
//               } else {
//                 toast.warn(updateDet?.message || "Update Failed");
//               }
//             } else {
//               history.push({
//                 pathname: "/login",
//               });
//             }
//           // }
//         // });
//             } else {
//         if (user) {
//           history.push({
//             pathname: `/payment`,
//             state: { data: data },
//           });
//         } else {
//           history.push({
//             pathname: "/login",
//           });
//         }
//       }
//     };


//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         height: "100%", // Takes full height from parent
//         display: "flex",
//         flexDirection: "column",
//         borderRadius: 3,
//         overflow: "hidden",
//         background: "linear-gradient(145deg, #f8f9fa 0%, #ffffff 100%)",
//         border: "1px solid #e0e0e0",
//       }}
//     >
//       {defaultPlan ? (
//         <Box
//           sx={{
//             p: 3,
//             height: "100%",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//           }}
//         >
//           <Box sx={{ textAlign: "center", mb: 2 }}>
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 mb: 2,
//               }}
//             >
//               <AttachMoneyIcon sx={{ fontSize: 40, color: "#4caf50" }} />
//               <Typography
//                 variant="h2"
//                 sx={{ fontWeight: 700, color: "#4caf50" }}
//               >
//                 0
//               </Typography>
//               <Typography
//                 variant="h6"
//                 sx={{ color: "text.secondary", alignSelf: "flex-end", mb: 1 }}
//               >
//                 /Month
//               </Typography>
//             </Box>
//           </Box>
//           <Chip
//             label="Free Version"
//             color="success"
//             sx={{
//               fontWeight: 700,
//               fontSize: "16px",
//               py: 2.5,
//               borderRadius: 2,
//             }}
//           />
//         </Box>
//       ) : (
//         <Box
//           sx={{
//             height: "100%",
//             display: "flex",
//             flexDirection: "column",
//           }}
//         >
//           {(location.pathname === "/pricedetails" ||
//             location.pathname === "/homepricedetails") && (
//             <Typography
//               variant="h6"
//               sx={{
//                 textAlign: "center",
//                 py: 2,
//                 fontWeight: 600,
//                 bgcolor: "primary.main",
//                 color: "white",
//               }}
//             >
//               {planName}
//             </Typography>
//           )}

//           <Box
//             sx={{ p: 3, flexGrow: 1, display: "flex", flexDirection: "column" }}
//           >
//             {/* Price Display - Fixed height */}
//             <Box sx={{ minHeight: "120px", textAlign: "center", mb: 2 }}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <AttachMoneyIcon
//                   sx={{ fontSize: 28, color: "primary.main", mb: 1 }}
//                 />
//                 <Typography
//                   variant="h2"
//                   sx={{
//                     fontWeight: 700,
//                     color: "primary.main",
//                     fontSize: price_size,
//                   }}
//                 >
//                   {details.price}
//                 </Typography>
//                 <Typography
//                   variant="h6"
//                   sx={{ color: "text.secondary", alignSelf: "flex-end", mb: 2 }}
//                 >
//                   /{details.period && details.period.slice(0, -2)}
//                 </Typography>
//               </Box>
//             </Box>

//             {/* User Count Selector - Fixed height */}
//             <Box
//               sx={{
//                 minHeight:
//                   plan_mode.mode === "Team" && user_count_list.length >= 1
//                     ? "80px"
//                     : "0px",
//                 mb: 2,
//               }}
//             >
//               {plan_mode.mode === "Team" && user_count_list.length >= 1 && (
//                 <FormControl fullWidth size="small">
//                   <Box
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 1,
//                       mb: 1,
//                     }}
//                   >
//                     <PeopleIcon
//                       sx={{ fontSize: 20, color: "text.secondary" }}
//                     />
//                     <Typography
//                       variant="body2"
//                       sx={{ fontWeight: 600, color: "text.secondary" }}
//                     >
//                       User count
//                     </Typography>
//                   </Box>
//                   <Select
//                     defaultValue={user_count_list[0]?.user_count}
//                     onChange={(e) => dropOnChange(e.target.value)}
//                     sx={{ borderRadius: 2 }}
//                   >
//                     {user_count_list.map((obj) => (
//                       <MenuItem value={obj.user_count} key={obj.price}>
//                         {obj.user_count} users
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               )}
//             </Box>

//             {/* Plan Details - Fixed height with scroll */}
//             {planList && (
//               <Box
//                 sx={{
//                   height: "140px", // Fixed height
//                   overflowY: "auto",
//                   mb: 2,
//                   p: 2,
//                   bgcolor: "#f5f5f5",
//                   borderRadius: 2,
//                   "&::-webkit-scrollbar": {
//                     width: "6px",
//                   },
//                   "&::-webkit-scrollbar-thumb": {
//                     backgroundColor: "#ccc",
//                     borderRadius: "3px",
//                   },
//                 }}
//               >
//                 <Typography
//                   variant="body2"
//                   component="div"
//                   sx={{ "& ul": { pl: 2, m: 0 }, "& li": { mb: 0.5 } }}
//                 >
//                   {planList}
//                 </Typography>
//               </Box>
//             )}

//             {/* Subscribe Button - Fixed at bottom */}
//             {details.price > 0 && (
//               <Box sx={{ mt: "auto" }}>
//                 {hide === true || hide_mode === true ? (
//                   <Button
//                     component={Link}
//                     to="/login"
//                     variant="contained"
//                     fullWidth
//                     sx={{
//                       borderRadius: 3,
//                       textTransform: "none",
//                       py: 1.5,
//                       fontWeight: 600,
//                       fontSize: "16px",
//                     }}
//                   >
//                     SIGN IN
//                   </Button>
//                 ) : (
//                   <>
//                     {!currentUser?.isAdmin && (
//                       <Button
//                         variant="contained"
//                         fullWidth
//                         onClick={buyPlan}
//                         sx={{
//                           borderRadius: 3,
//                           textTransform: "none",
//                           py: 1.5,
//                           fontWeight: 600,
//                           fontSize: "16px",
//                           background:
//                             "linear-gradient(45deg, #667eea 30%, #764ba2 90%)",
//                           "&:hover": {
//                             background:
//                               "linear-gradient(45deg, #764ba2 30%, #667eea 90%)",
//                           },
//                         }}
//                       >
//                         {currentUser?.planName === planName
//                           ? "Resubscribe"
//                           : "Subscribe"}
//                       </Button>
//                     )}
//                   </>
//                 )}
//               </Box>
//             )}
//           </Box>
//         </Box>
//       )}
//     </Paper>
//   );
// }

// const mapStateToProps = (state) => ({
//   currentUser: state.user.currentUser,
// });

// const mapDispatchToProps = (dispatch) => ({
//   setCurrentUser: (user) => dispatch(setCurrentUser(user)),
// });

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(withRouter(PriceTag));

import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import userService from "../../services/userService";
import authService from "../../services/authService";
import { connect, useSelector } from "react-redux";
import { setCurrentUser } from "../../redux/user/user.actions";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  Paper,
  Chip,
  Divider,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PeopleIcon from "@mui/icons-material/People";
import paymentServices from "../../services/paymentServices";
import { toast, ToastContainer } from "react-toastify";

function PriceTag({
  price_detail,
  planPeriod,
  planName,
  planList,
  features = [],
  plan_mode,
  price_size = "50px",
  bg_color = "bg-gray",
  hide,
  history,
  currentUser,
  hide_mode,
  plan_id,
  defaultPlan,
  setCurrentPlan,
  setCurrentplancheck,
  setCurrentUser,
  isCurrentPlan,
}) {
  let detail = { price: null, user_count: null, period: null, plan_mode: null };
  const [details, setdetails] = useState(detail);
  const [user_count_list, setuser_count] = useState([]);
  let [plan_period, setplan_period] = useState(planPeriod);
  const [location, setLocation] = useState(useLocation());
  const userDetails = useSelector((user) => user);
  const requestedBillingLabel =
    (planPeriod || "").toLowerCase().includes("year") ||
    (planPeriod || "").toLowerCase().includes("annual")
      ? "year"
      : "month";

  const planFeatureCatalog = {
    basic: [
      { name: `5,000 words/${requestedBillingLabel}`, access: true },
      { name: "Basic AI writing tools", access: true },
      { name: "Grammar Check", access: true },
      { name: "Paraphraser", access: true },
      { name: "AI Blog Writer", access: false },
      { name: "Team Collaboration", access: false },
      { name: "Advanced AI Tools", access: false },
      { name: "Priority Support", access: false },
    ],
    professional: [
      { name: `50,000 words/${requestedBillingLabel}`, access: true },
      { name: "All Basic features", access: true },
      { name: "AI Blog Writer", access: true },
      { name: "Team Collaboration", access: true },
      { name: "Advanced AI Tools", access: true },
      { name: "Priority Support", access: false },
    ],
    premium: [
      { name: `Unlimited words/${requestedBillingLabel}`, access: true },
      { name: "All Professional features", access: true },
      { name: "Advanced AI Models", access: true },
      { name: "Priority Support", access: true },
      { name: "Team Analytics", access: true },
      { name: "Custom Templates", access: true },
    ],
    enterprise: [
      { name: "Everything in Premium", access: true },
      { name: "Custom AI Solutions", access: true },
      { name: "Dedicated Account Manager", access: true },
      { name: "SLA & Priority Support", access: true },
      { name: "Advanced Security", access: true },
      { name: "Custom Integrations", access: true },
    ],
  };

  const getCatalogKey = (name = "") => {
    const lowerName = name.toLowerCase();
    if (lowerName.includes("enterprise")) return "enterprise";
    if (lowerName.includes("premium")) return "premium";
    if (lowerName.includes("professional")) return "professional";
    return "basic";
  };

  const apiFeatureList = features.map((feature) => ({
    name: feature?.name,
    access: feature?.access === true || feature?.access === "true",
  }));

  const featureList =
    planFeatureCatalog[getCatalogKey(planName)] ||
    apiFeatureList;

  const normalizePeriod = (period = "") => {
    const normalized = period.toLowerCase();
    if (normalized.includes("year") || normalized.includes("annual")) {
      return "yearly";
    }
    if (normalized.includes("month")) {
      return "monthly";
    }
    if (normalized.includes("quarter")) {
      return "quarterly";
    }
    return normalized;
  };

  const getPeriodKey = (period) => {
    const time_period = Object.keys(price_detail || {});
    if (time_period.length === 0) return null;

    const selectedPeriod = time_period.find(
      (key) => normalizePeriod(key) === normalizePeriod(period),
    );

    return selectedPeriod || time_period[0];
  };

  useEffect(() => {
    initialCall(planPeriod);
  }, [planPeriod, price_detail]);

  const initialCall = (period) => {
    const requestedPeriod = period || plan_period;
    const selectedPeriod = getPeriodKey(period || plan_period);
    if (!selectedPeriod) return;

    let { price, user_count } = price_detail[selectedPeriod][0];
    const requestedYearly = normalizePeriod(requestedPeriod) === "yearly";
    const selectedYearly = normalizePeriod(selectedPeriod) === "yearly";

    if (requestedYearly && !selectedYearly && !price_detail.yearly) {
      const numericPrice = Number(price);
      if (!Number.isNaN(numericPrice)) {
        price = numericPrice * 12;
      }
    }

    setdetails({
      price,
      user_count,
      period: requestedYearly ? "yearly" : selectedPeriod,
    });
    setuser_count(price_detail[selectedPeriod]);
    setplan_period(selectedPeriod);
  };

  const dropOnChange = (count) => {
    let arr = price_detail[plan_period];
    let findObj = arr.find((obj) => obj.user_count == count);
    const { price, user_count } = findObj;
    setdetails({ price, user_count, period: plan_period });
  };

  const displayBillingLabel =
    normalizePeriod(details.period || planPeriod) === "yearly"
      ? "year"
      : "month";

  const getUpdatedUser = (response) =>
    response?.user || response?.data?.user || response?.data?.data?.user;

  const isSubscriptionUpdateSuccessful = (response) => {
    const status = Number(response?.status || response?.data?.status);
    return (
      status === 200 ||
      response?.success === true ||
      Boolean(getUpdatedUser(response)?.plan)
    );
  };

  const redirectToLogin = () => {
    sessionStorage.removeItem("token");
    localStorage.removeItem("token");
    localStorage.removeItem("is_guest");
    localStorage.removeItem("guest_id");
    setCurrentUser(null);
    history.replace("/login");
  };

  const buyPlan = async () => {
    let data = {
      ...details,
      planName,
      plan_id,
      plan_mode: plan_mode.mode,
    };
    const user = authService.getCurrentUser();

    if (
      currentUser?.planName !== data.planName &&
      currentUser?.planName !== "PET Basic Plan"
    ) {
      if (user) {
        const updateDetails = {
          planId: plan_id,
          planName: planName,
          userEmail: userDetails.user?.currentUser?.email,
          duration: data.period,
        };
        console.log("updateDetails", updateDetails, data, userDetails.user);
        const updateDet = await paymentServices.UpdateSubs(updateDetails);
        console.log("updateDet", updateDet);
        if (isSubscriptionUpdateSuccessful(updateDet)) {
          const updatedUser = getUpdatedUser(updateDet);
          toast.success("Updated Successfully");
          setCurrentplancheck((prev) => !prev);
          if (updatedUser) {
            setCurrentUser(updatedUser);
          }
          if (updatedUser?.plan?.name) {
            setCurrentPlan(updatedUser.plan.name);
          }
          redirectToLogin();
        } else {
          toast.warn(updateDet?.message || "Update Failed");
        }
      } else {
        history.push({ pathname: "/login" });
      }
    } else {
      if (user) {
        history.push({ pathname: `/payment`, state: { data: data } });
      } else {
        history.push({ pathname: "/login" });
      }
    }
  };

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {defaultPlan ? (
        /* ─── FREE PLAN ─── */
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 3,
            gap: 2,
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: 0.5,
              }}
            >
              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 700,
                  color: "#22c55e",
                  mt: "6px",
                  lineHeight: 1,
                }}
              >
                $
              </Typography>
              <Typography
                sx={{
                  fontSize: "64px",
                  fontWeight: 800,
                  color: "#22c55e",
                  lineHeight: 1,
                  letterSpacing: "-2px",
                }}
              >
                0
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#94a3b8",
                  alignSelf: "flex-end",
                  mb: "10px",
                  fontWeight: 500,
                }}
              >
                /{displayBillingLabel}
              </Typography>
            </Box>
          </Box>

          <Chip
            icon={<CheckCircleRoundedIcon sx={{ fontSize: "16px !important" }} />}
            label="Free Forever"
            sx={{
              px: 1.5,
              py: 2.5,
              fontWeight: 700,
              fontSize: "14px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
              color: "#065f46",
              border: "1px solid rgba(34,197,94,0.25)",
              "& .MuiChip-icon": { color: "#065f46 !important" },
            }}
          />
          <Box
            sx={{
              width: "100%",
              minHeight: { xs: "230px", md: "250px" },
              maxHeight: { xs: "280px", md: "310px" },
              overflowY: "auto",
              mt: 2,
              pr: 0.5,
            }}
          >
            {featureList.slice(0, 8).map((feature, index) => (
              <Box
                key={`${feature.name}-${index}`}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 1.15,
                  color: feature.access ? "#334155" : "#94a3b8",
                  fontSize: "13px",
                  fontWeight: 500,
                  lineHeight: 1.35,
                }}
              >
                {feature.access ? (
                  <CheckCircleRoundedIcon
                    sx={{ fontSize: 16, flexShrink: 0, color: "#60a5fa" }}
                  />
                ) : (
                  <LockOutlinedIcon
                    sx={{ fontSize: 16, flexShrink: 0, color: "#8b5cf6" }}
                  />
                )}
                <Box component="span">{feature.name}</Box>
              </Box>
            ))}
          </Box>
          <Button
            component={Link}
            to="/login"
            variant="outlined"
            fullWidth
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              py: 1.2,
              fontWeight: 700,
              color: "#2563eb",
              borderColor: "#60a5fa",
              "&:hover": {
                borderColor: "#2563eb",
                background: "rgba(96,165,250,0.08)",
              },
            }}
          >
            Start Free
          </Button>
        </Box>
      ) : (
        /* ─── PAID PLAN ─── */
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          {/* Plan name header (only on detail pages) */}
          {(location.pathname === "/pricedetails" ||
            location.pathname === "/homepricedetails") && (
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                py: 2,
                fontWeight: 700,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                borderRadius: "12px",
                mb: 2,
                letterSpacing: "-0.2px",
              }}
            >
              {planName}
            </Typography>
          )}

          {/* Price Row */}
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: 0.5,
              }}
            >
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: isCurrentPlan ? "rgba(255,255,255,0.7)" : "#667eea",
                  mt: "8px",
                  lineHeight: 1,
                }}
              >
                $
              </Typography>
              <Typography
                sx={{
                  fontSize: price_size,
                  fontWeight: 800,
                  color: isCurrentPlan ? "#ffffff" : "#667eea",
                  lineHeight: 1,
                  letterSpacing: "-2px",
                }}
              >
                {details.price}
              </Typography>
              <Box sx={{ alignSelf: "flex-end", mb: "10px" }}>
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: isCurrentPlan ? "rgba(255,255,255,0.55)" : "#94a3b8",
                    fontWeight: 500,
                    lineHeight: 1.2,
                  }}
                >
                  /{displayBillingLabel}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* User Count Selector */}
          {plan_mode.mode === "Team" && user_count_list.length >= 1 && (
            <Box sx={{ mb: 2 }}>
              <FormControl fullWidth size="small">
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
                >
                  <PeopleIcon
                    sx={{
                      fontSize: 18,
                      color: isCurrentPlan ? "rgba(255,255,255,0.6)" : "#94a3b8",
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: isCurrentPlan ? "rgba(255,255,255,0.7)" : "#64748b",
                    }}
                  >
                    Number of users
                  </Typography>
                </Box>
                <Select
                  defaultValue={user_count_list[0]?.user_count}
                  onChange={(e) => dropOnChange(e.target.value)}
                  sx={{
                    borderRadius: "10px",
                    fontSize: "14px",
                    background: isCurrentPlan
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(102,126,234,0.04)",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: isCurrentPlan
                        ? "rgba(255,255,255,0.2)"
                        : "rgba(102,126,234,0.2)",
                    },
                    "& .MuiSelect-select": {
                      color: isCurrentPlan ? "#fff" : "#1a1a2e",
                    },
                    "& .MuiSvgIcon-root": {
                      color: isCurrentPlan ? "rgba(255,255,255,0.6)" : "#64748b",
                    },
                  }}
                >
                  {user_count_list.map((obj) => (
                    <MenuItem value={obj.user_count} key={obj.price}>
                      {obj.user_count} users
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}

          {/* Plan Features List */}
          {false && planList && (
            <>
              <Divider
                sx={{
                  mb: 2,
                  borderColor: isCurrentPlan
                    ? "rgba(255,255,255,0.12)"
                    : "rgba(102,126,234,0.1)",
                }}
              />
              <Box
                sx={{
                  flexGrow: 1,
                  minHeight: { xs: "210px", md: "240px" },
                  maxHeight: { xs: "260px", md: "300px" },
                  overflowY: "auto",
                  mb: 2,
                  pr: 0.5,
                  "&::-webkit-scrollbar": { width: "4px" },
                  "&::-webkit-scrollbar-track": { background: "transparent" },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: isCurrentPlan
                      ? "rgba(255,255,255,0.2)"
                      : "rgba(102,126,234,0.2)",
                    borderRadius: "2px",
                  },
                }}
              >
                <Typography
                  variant="body2"
                  component="div"
                  sx={{
                    fontSize: "13px",
                    color: isCurrentPlan ? "rgba(255,255,255,0.75)" : "#475569",
                    lineHeight: 1.6,
                    "& ul": { pl: 1.5, m: 0, listStyle: "none" },
                    "& li": {
                      mb: 0.6,
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "6px",
                      "&::before": {
                        content: '"✓"',
                        color: isCurrentPlan ? "#86efac" : "#667eea",
                        fontWeight: 700,
                        flexShrink: 0,
                        marginTop: "1px",
                      },
                    },
                    "& lh": {
                      display: "block",
                      fontWeight: 700,
                      fontSize: "12px",
                      textTransform: "uppercase",
                      letterSpacing: "0.8px",
                      color: isCurrentPlan ? "rgba(255,255,255,0.45)" : "#94a3b8",
                      mb: 1,
                    },
                  }}
                >
                  {planList}
                </Typography>
              </Box>
            </>
          )}

          <Box
            sx={{
              flexGrow: 1,
              minHeight: { xs: "230px", md: "250px" },
              maxHeight: { xs: "280px", md: "310px" },
              overflowY: "auto",
              mb: 2,
              pr: 0.5,
              "&::-webkit-scrollbar": { width: "4px" },
              "&::-webkit-scrollbar-track": { background: "transparent" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: isCurrentPlan
                  ? "rgba(255,255,255,0.2)"
                  : "rgba(102,126,234,0.2)",
                borderRadius: "2px",
              },
            }}
          >
            {featureList.slice(0, 8).map((feature, index) => (
              <Box
                key={`${feature.name}-${index}`}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 1.15,
                  color: feature.access
                    ? isCurrentPlan
                      ? "rgba(255,255,255,0.86)"
                      : "#334155"
                    : isCurrentPlan
                    ? "rgba(255,255,255,0.48)"
                    : "#94a3b8",
                  fontSize: "13px",
                  fontWeight: 500,
                  lineHeight: 1.35,
                }}
              >
                {feature.access ? (
                  <CheckCircleRoundedIcon
                    sx={{
                      fontSize: 16,
                      flexShrink: 0,
                      color: isCurrentPlan ? "#86efac" : "#60a5fa",
                    }}
                  />
                ) : (
                  <LockOutlinedIcon
                    sx={{
                      fontSize: 16,
                      flexShrink: 0,
                      color: isCurrentPlan ? "rgba(255,255,255,0.35)" : "#8b5cf6",
                    }}
                  />
                )}
                <Box component="span">{feature.name}</Box>
              </Box>
            ))}
          </Box>

          {/* Subscribe / Sign-in Button */}
          {details.price > 0 && (
            <Box sx={{ mt: "auto" }}>
              {hide === true || hide_mode === true ? (
                <Button
                  component={Link}
                  to="/login"
                  variant="contained"
                  fullWidth
                  sx={{
                    borderRadius: "12px",
                    textTransform: "none",
                    py: 1.4,
                    fontWeight: 700,
                    fontSize: "15px",
                    letterSpacing: "0.2px",
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    boxShadow: "0 4px 20px rgba(102,126,234,0.35)",
                    "&:hover": {
                      background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                      boxShadow: "0 6px 24px rgba(102,126,234,0.5)",
                      transform: "translateY(-1px)",
                    },
                    transition: "all 0.25s ease",
                  }}
                >
                  Sign In to Get Started
                </Button>
              ) : (
                <>
                  {!currentUser?.isAdmin && (
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={buyPlan}
                      sx={{
                        borderRadius: "12px",
                        textTransform: "none",
                        py: 1.4,
                        fontWeight: 700,
                        fontSize: "15px",
                        letterSpacing: "0.2px",
                        background: isCurrentPlan
                          ? "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)"
                          : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        color: isCurrentPlan ? "#1a1a2e" : "#ffffff",
                        boxShadow: isCurrentPlan
                          ? "0 4px 20px rgba(247,151,30,0.35)"
                          : "0 4px 20px rgba(102,126,234,0.35)",
                        "&:hover": {
                          background: isCurrentPlan
                            ? "linear-gradient(135deg, #ffd200 0%, #f7971e 100%)"
                            : "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                          boxShadow: isCurrentPlan
                            ? "0 6px 24px rgba(247,151,30,0.5)"
                            : "0 6px 24px rgba(102,126,234,0.5)",
                          transform: "translateY(-1px)",
                        },
                        transition: "all 0.25s ease",
                      }}
                    >
                      {currentUser?.planName === planName
                        ? "🔄 Resubscribe"
                        : isCurrentPlan
                        ? "✨ Current Plan"
                        : "🚀 Get Started"}
                    </Button>
                  )}
                </>
              )}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PriceTag));
